export const ACCESS_TOKEN = 'hirou-user-token';
export const USERNAME = 'hirou-username';
export const USER_ID = 'hirou-userid';
export const USER_GROUPS = 'hirou-user-groups';
export const USER_COMPANY = 'hirou-user-company';
export const USER_TYPE = 'hirou-user-type';
export const USER_EMAIL = 'hirou-user-email';
